/**
 * Winnstech full phone prices, paid on collection.
 * Owner-approved 20% collection-price reduction: 24 August 2026.
 * Shopify variant prices remain separate reservation deposits.
 */
window.WinnstechPricing = Object.freeze({
  'iPhone 12 Pro Max': {'128GB':160,'256GB':188,'512GB':220},
  'iPhone 12 Pro': {'128GB':120,'256GB':156,'512GB':180},
  'iPhone 12 Mini': {'64GB':88,'128GB':104,'256GB':112},
  'iPhone 12': {'64GB':96,'128GB':116,'256GB':148},
  'iPhone 13 Pro Max': {'128GB':232,'256GB':260,'512GB':304,'1TB':344},
  'iPhone 13 Pro': {'128GB':200,'256GB':232,'512GB':252,'1TB':284},
  'iPhone 13 Mini': {'128GB':132,'256GB':156,'512GB':184},
  'iPhone 13': {'128GB':152,'256GB':200,'512GB':240},
  'iPhone 14': {'128GB':180,'256GB':232,'512GB':248},
  'iPhone 14 Pro Max': {'128GB':292,'256GB':336,'512GB':364,'1TB':396},
  'iPhone 14 Pro': {'128GB':236,'256GB':284,'512GB':304,'1TB':336},
  'iPhone 14 Plus': {'128GB':192,'256GB':236,'512GB':260},
  'iPhone 15 Pro Max': {'256GB':200,'512GB':448,'1TB':492},
  'iPhone 15 Pro': {'128GB':332,'256GB':376,'512GB':408,'1TB':428},
  'iPhone 15 Plus': {'128GB':292,'256GB':336,'512GB':356},
  'iPhone 15': {'128GB':260,'256GB':320,'512GB':336},
  'iPhone 16 Pro Max': {'256GB':511.20,'512GB':636,'1TB':668},
  'iPhone 16 Pro': {'128GB':415.20,'256GB':492,'512GB':552,'1TB':596},
  'iPhone 16 Plus': {'128GB':372,'256GB':428,'512GB':468},
  'iPhone 16': {'128GB':360,'256GB':428,'512GB':448},
  'iPhone Air': {'256GB':492,'512GB':552,'1TB':596},
  'iPhone 17 Pro Max': {'256GB':640,'512GB':740,'1TB':812,'2TB':876},
  'iPhone 17 Pro': {'256GB':592,'512GB':648,'1TB':700},
  'iPhone 17': {'256GB':480,'512GB':520}
});
